export const REDIRECT_URI_PARAM = "redirect_uri";
export const HOPPER_USER_ID_PARAM = "hopperUserId";
